import { RoundCommandError } from "../round/round-errors.js";
import type { SimulatorRoundSettings } from "./simulator-types.js";

export function validateSimulatorSettings(
  value: SimulatorRoundSettings | undefined,
  kind: string,
): void {
  if (!value) return; // Older snapshots retain unknown device settings.
  if (
    kind !== "simulator" ||
    value.version !== 1 ||
    !value.system?.trim() ||
    value.system.trim().length > 80 ||
    !Number.isFinite(Date.parse(value.confirmedAt))
  )
    throw new RoundCommandError(
      "Confirm the simulator system and settings before play.",
    );
  const gimme = value.gimme;
  if (gimme?.mode === "off") {
    if (gimme.distance !== null || gimme.unit !== null)
      throw new RoundCommandError("Gimme off cannot include a distance.");
  } else if (
    gimme?.mode !== "distance" ||
    !["m", "ft"].includes(gimme.unit) ||
    !Number.isFinite(gimme.distance) ||
    gimme.distance <= 0 ||
    gimme.distance > 30
  )
    throw new RoundCommandError(
      "Enter the actual gimme distance and unit, or choose gimme off.",
    );
  if (
    value.catalog &&
    (value.catalog.source !== "trackman_graphql_courses" ||
      value.catalog.availability !== "unverified" ||
      !Number.isFinite(Date.parse(value.catalog.exportedAt)) ||
      !value.catalog.courseIdentifier ||
      !value.catalog.courseVersion)
  )
    throw new RoundCommandError("The simulator catalog provenance is invalid.");
}
